/* Zilch rebuild: shared motion runtime for every zn-* section.
   Ported from preview-au/site.js (7 Oct 2026). Only touches elements inside .zn wrappers.
   Loaded (deferred) by snippets/zn-head.liquid; guarded so several zn sections on one page run it once.
   Also exposes window.znCart.add(items) for buy buttons (see PATTERNS.md). */
(function(){
  if (window.__znSite) return;
  window.__znSite = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(sel){ return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  // ---------- cart: add to cart and open the Prestige cart drawer ----------
  // items: [{id, quantity, selling_plan}] (selling_plan optional). Returns a Promise of the /cart/add.js JSON.
  window.znCart = {
    add: function(items){
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var sections = [];
      // Prestige's <cart-drawer> pushes its section id here so the add response bundles its new HTML
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      var body = { items: items.map(function(i){
        var o = { id: Number(i.id), quantity: i.quantity || 1 };
        if (i.selling_plan) o.selling_plan = Number(i.selling_plan);
        return o;
      }) };
      if (sections.length) { body.sections = sections.join(','); body.sections_url = location.pathname; }
      var added;
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function(r){
        return r.json().then(function(j){ if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
      }).then(function(j){
        added = j;
        return fetch(root + 'cart.js').then(function(r){ return r.json(); });
      }).then(function(cart){
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        cart.sections = added.sections || {};
        var detail = { items: added.items || [added], cart: cart, onSuccessDo: 'force_open_drawer' };
        document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: detail }));
        if (sections.length && document.querySelector('cart-drawer')) {
          // cart-drawer re-renders from cart.sections and opens (baseEvent variant:add + force_open_drawer)
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true,
            detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart } }));
        } else {
          location.href = root + 'cart';
        }
        return added;
      }).catch(function(e){
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        throw e;
      });
    }
  };

  function boot(){
    // scroll progress bar
    var bar = document.createElement('div');
    bar.className = 'zn-progress';
    document.body.appendChild(bar);
    window.addEventListener('scroll', function(){
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
    }, {passive:true});

    // reveal on scroll
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('zn-in'); io.unobserve(e.target); }
      });
    }, {threshold:.16, rootMargin:'0px 0px -40px 0px'});
    $$('.zn [data-rv], .zn [data-rv-group]').forEach(function(el){ io.observe(el); });

    // herb/ingredient cards: one swipeable row on every page, arrows on desktop
    (function(){
      var rows = [];
      $$('.zn .ing, .zn .ing-card').forEach(function(el){
        var p = el.parentNode; if (rows.indexOf(p) < 0) rows.push(p);
      });
      rows.forEach(function(row){
        var n = [].filter.call(row.children, function(c){ return c.classList.contains('ing') || c.classList.contains('ing-card'); }).length;
        if (n < 3) return;
        row.classList.add('zn-herb-row');
        var hb = document.createElement('div'); hb.className = 'zn-herb-bar';
        hb.innerHTML = '<span></span>' +
          '<span class="zn-herb-nav"><button type="button" aria-label="Previous">&#8249;</button><button type="button" aria-label="Next">&#8250;</button></span>';
        row.parentNode.insertBefore(hb, row.nextSibling);
        var btns = hb.querySelectorAll('button');
        function step(d){ row.scrollBy({left: d * Math.max(240, row.clientWidth * .8), behavior: 'smooth'}); }
        btns[0].addEventListener('click', function(){ step(-1); });
        btns[1].addEventListener('click', function(){ step(1); });
        // first time the row comes into view: peek right and back so people see it scrolls
        if ('IntersectionObserver' in window && !reduced) {
          var peek = new IntersectionObserver(function(es){
            if (!es[0].isIntersecting) return;
            peek.disconnect();
            setTimeout(function(){
              row.scrollTo({left: Math.min(160, row.scrollWidth - row.clientWidth), behavior: 'smooth'});
              setTimeout(function(){ row.scrollTo({left: 0, behavior: 'smooth'}); }, 900);
            }, 350);
          }, {threshold: .6});
          peek.observe(row);
        }
      });
    })();

    // marquee: duplicate track content once for seamless loop
    $$('.zn .zn-marquee-track').forEach(function(t){
      var base = t.innerHTML, n = 1;
      while (t.scrollWidth < window.innerWidth * 1.1 && n < 12) { t.innerHTML += base; n++; }
      t.innerHTML += t.innerHTML;
    });

    // tilt (fine pointers only)
    if (!reduced && window.matchMedia('(pointer: fine)').matches){
      $$('.zn .zn-tilt').forEach(function(card){
        card.addEventListener('mousemove', function(ev){
          var r = card.getBoundingClientRect();
          var x = (ev.clientX - r.left) / r.width - .5;
          var y = (ev.clientY - r.top) / r.height - .5;
          card.style.transform = 'perspective(800px) rotateX(' + (-y*6) + 'deg) rotateY(' + (x*8) + 'deg) translateY(-4px)';
        });
        card.addEventListener('mouseleave', function(){ card.style.transform = ''; });
      });
    }

    // animated counters: <span data-count="92">
    var cio = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        var el = e.target, target = Number(el.getAttribute('data-count')), start = null;
        function step(ts){
          if (!start) start = ts;
          var p = Math.min((ts - start) / 1200, 1);
          el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))).toLocaleString();
          if (p < 1) requestAnimationFrame(step);
        }
        if (reduced){ el.textContent = target.toLocaleString(); } else { requestAnimationFrame(step); }
      });
    }, {threshold:.5});
    $$('.zn [data-count]').forEach(function(el){ cio.observe(el); });

    // swipeable product gallery: #galleryMain + #thumbs img (clicking a thumb or swiping the main image)
    var gm = document.getElementById('galleryMain');
    var gthumbs = $$('#thumbs img');
    if (gm && gthumbs.length > 1) {
      var gi = 0;
      var gwrap = gm.parentElement;
      var dots = document.createElement('div');
      dots.className = 'zn-gdots';
      gthumbs.forEach(function (_, i) {
        var d = document.createElement('span');
        if (i === 0) d.className = 'on';
        dots.appendChild(d);
      });
      gwrap.appendChild(dots);
      var gGo = function (i) {
        gi = (i + gthumbs.length) % gthumbs.length;
        gm.src = gthumbs[gi].getAttribute('data-full') || gthumbs[gi].src;
        gm.alt = gthumbs[gi].alt;
        // .zn-cut = transparent bottle render (padded + drop shadow); photos fill the frame
        gm.classList.toggle('zn-cut', gthumbs[gi].classList.contains('zn-cut'));
        gthumbs.forEach(function (t, j) { t.classList.toggle('on', j === gi); });
        dots.querySelectorAll('span').forEach(function (d, j) { d.classList.toggle('on', j === gi); });
      };
      window.znGalleryGo = gGo;
      gthumbs.forEach(function (t, i) { t.addEventListener('click', function () { gGo(i); }); });
      var sx = null, sy = null;
      gwrap.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      gwrap.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) gGo(gi + (dx < 0 ? 1 : -1));
        sx = null;
      }, { passive: true });
    }

    // autoplay videos in view: .zn-autoplay (a <video> or a wrapper holding one)
    var vio = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        var v = e.target.tagName === 'VIDEO' ? e.target : e.target.querySelector('video');
        if (!v) return;
        if (e.isIntersecting){ v.play().catch(function(){}); } else { v.pause(); }
      });
    }, {threshold:.4});
    $$('.zn .zn-autoplay').forEach(function(el){ vio.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* zn-a11y-scroll: horizontal scrollers (herb/ingredient rows, gallery thumbs) must be reachable by keyboard (WCAG 2.1.1) */
(function(){
  function run(){
    /* Loox rating link: accessible name must contain its visible text (WCAG 2.5.3) */
    document.querySelectorAll('.zn a[href$="#looxReviewsFrame"][aria-label]').forEach(function(a){
      var t = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (t && a.getAttribute('aria-label').indexOf(t) < 0) a.setAttribute('aria-label', t + ', scroll to reviews');
    });
    document.querySelectorAll('.zn .zn-herb-row, .zn #thumbs, .zn .scroll-x').forEach(function(el){
      if (el.scrollWidth <= el.clientWidth + 1 || el.hasAttribute('tabindex')) return;
      el.setAttribute('tabindex', '0');
      if (!el.hasAttribute('role')) el.setAttribute('role', 'region');
      if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', el.id === 'thumbs' ? 'Product images' : 'Scrollable list');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', function(){ run(); setTimeout(run, 2500); setTimeout(run, 6000); setTimeout(run, 12000); });  /* apps (Loox) inject late */
})();
